import { createContext, useContext } from 'react'

// The context will hold the current theme's class name (e.g., 'theme-soe')
export const ThemeContext = createContext<string | null>(null)

/**
 * A custom hook to easily access the theme from the context.
 */
export const useTheme = (): string | null => {
  const context = useContext(ThemeContext)
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}
